import {CartItem} from "./cartitem";

export class Cart {

    public cartItems: Array<CartItem> = new Array();

}